import React from 'react';
import { Link } from 'react-router-dom';
import ServicesComponent from '../components/Services';
import ProcessSection from '../components/process/ProcessSection';
import Footer from '../components/Footer';
import NavBar from '../components/Navbar/NavBar';
import { useDocTitle } from '../components/CustomHook';
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const Services = () => {
  useDocTitle('kesnelDigital - Services');
  const { t } = useTranslation();
  return (
    <I18nextProvider i18n={i18n}>
      <Helmet>
        <meta name="description" content="Discover a wide range of services offered by Kesnel Digital. We specialize in web development, mobile app development, innovative software solutions, and IT consulting. Elevate your business with our expertise and creative solutions." />
      </Helmet>
      <NavBar />

      <div className="pt-16 lg:pt-20 bg-slatex-50">
        <ServicesComponent />
        <div className="bg-slatex-50 pb-20 lg:pb-28 text-center">
          <Link to="/contact" className="btn-primary">
            {t('services.contact')}
            <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
          </Link>
        </div>
      </div>

      <ProcessSection />

      <Footer />
    </I18nextProvider>
  );
}

export default Services;
